import { parseCurl } from "./curl-parser";

/**
 * Generates a Postman collection JSON from a workflow object.
 * @param {object} workflow The workflow data containing the steps.
 * @returns {object} A Postman collection v2.1.0 object.
 */
export const generatePostmanCollection = (workflow) => {
  const collection = {
    info: {
      _postman_id: crypto.randomUUID(),
      name: workflow.displayText,
      description: workflow.description,
      schema:
        "https://schema.getpostman.com/json/collection/v2.1.0/collection.json",
    },
    item: [],
  };

  workflow.list.contentItems.forEach((step) => {
    const parsedCurl = parseCurl(step.codeSnippet);
    const url = new URL(parsedCurl.url);

    const postmanRequest = {
      name: step.stepTitle,
      request: {
        method: parsedCurl.method,
        header: parsedCurl.headers,
        body: parsedCurl.body,
        url: {
          raw: url.href,
          protocol: url.protocol.replace(/:$/, ""),
          host: url.hostname.split("."),
          path: url.pathname.split("/").filter(Boolean),
          query: Array.from(url.searchParams.entries()).map(([key, value]) => ({
            key,
            value,
          })),
        },
        description: step.stepDescription.html,
      },
      response: [],
    };

    collection.item.push(postmanRequest);
  });

  return collection;
};